import React from "react";

export const Header = props => {
    const {content} = props;
    return(
        <div className="header">
            <div className="name">{content.name}</div>
            <div className="title">{content.title}</div>
            <div className="title">
                <span className="e-mail">{content.eMail}</span>
                <span className="spacer">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                <span className="web-url">{content.webUrl}</span>
            </div>
            <div className='download-cv'>
                <a href="/assets/cv_hnn_2018_v2.pdf">Download CV</a>
            </div>
        </div>
    );
};

export const GenericSection = props => {
    const {content}       = props;
    let idx=0, paragraphs = [];
    for( let p of content.paragraphs ) {
        paragraphs[idx++] = <div key={"gs-"+idx} className="para">{p}</div>
    }
    return(
        <div className="generic section">
            <div className="section-title">{content.title}</div>
            {paragraphs}
        </div>
    );
};

export const SectionWithList = props => {
    const {content}      = props;
    let idx=0, listItems = [];
    for( let p of content.list ) {
        listItems[idx++] = <li key={"swl-" + idx} className="list-item">{p}</li>
    }
    return(
        <div className="section with-list">
            <div className="section-title">{content.title}</div>
            <ul className="list-in-section">
                {listItems}
            </ul>
        </div>
    );
};

export const WorkHistorySection = props => {
    const {content}      = props;
    const getInnerListItems = ( items ) => {
        let itemIdx = 0;
        const innerListItems = [];
        for (let item of items) {
            innerListItems[ itemIdx++ ] = <li key={ "inner-list-"+itemIdx } className="inner-list-item">{item}</li>
        }
        return innerListItems;
    };
    let idx=0, jobs = [];
    for( let j of content.jobList ) {
        jobs[idx++] = <div key={"job-" + idx} className="job-list-item">
            <div>{j.job}</div>
            <ul className="activity-list">{getInnerListItems(j.activities)}</ul>
        </div>;
    }
    return(
        <div className="section    dwork-history">
            <div className="section-title">{content.title}</div>
            {jobs}
        </div>
    );
};




// WEBPACK FOOTER //
// ./src/components/cv/CvPresentation.js